// macOS adds a __MACOSX folder of resource forks when it zips a folder, and those
// copies would otherwise sit outside the .gdb folder or pass for its tables.
const withoutMacOsMetadata = (filePaths: string[]) =>
  filePaths.filter((filePath) => !filePath.startsWith("__MACOSX/"));

export const isFileGeodatabase = (filePaths: string[]) => {
  const contentPaths = withoutMacOsMetadata(filePaths);
  return (
    contentPaths.length > 0 &&
    contentPaths.every((filePath) =>
      filePath
        .split("/")
        .slice(0, -1)
        .some((folder) => folder.toLowerCase().endsWith(".gdb")),
    )
  );
};

export const isCompleteFileGeodatabase = (filePaths: string[]) =>
  withoutMacOsMetadata(filePaths).some((filePath) =>
    filePath.toLowerCase().endsWith(".gdbtable"),
  );
